import $axios from '@/api/apiPublic';

const getDiscounts = async () => {
  const response = await $axios.get('discount/list');
  return response;
};

const getPrize = async category => {
  const response = await $axios.get(`discount/?category=${category}`);
  return response;
};

const sendDiscount = async data => {
  const response = await $axios.post('discount/', data);
  return response;
};

export default {
  getDiscounts,
  getPrize,
  sendDiscount,
};
